import React from 'react'
import { TourContext } from './TourContext'

export const withTour = (Component) => {
    return (props) => (
        <TourContext.Consumer>
            {(tourProps) => <Component {...props} tour={tourProps} />}
        </TourContext.Consumer>
    )
}
